import { cover } from '../../../../../../utility/constant/helper.constant'
import { color } from '../../../../../../utility/constant/color.constant'
import { Helper, WindowElement } from '../../../../../../classes/helper'
import { useMontage } from '../../../../../../context/montage.context'

export const WindowsSideGlassTop = () => {
  const { measure, ego, night } = useMontage()

  const { height, deltaY } = WindowElement.shapePositions(measure)
  const windowShape = WindowElement.shape(measure)

  const extrudeSettings = {
    depth: 0.008,
    bevelEnabled: false,
    bevelSegments: 20,
    steps: 2,
    bevelSize: 1,
    bevelThickness: 1,
  }

  return (
    <mesh
      castShadow={cover.terraceCover.castShadow}
      position={[
        Helper.convertToMeter(measure.userWidth / 2 - cover.bar.height / 2),
        Helper.convertToMeter(measure.userHeight - (height + deltaY)),
        Helper.convertToMeter(measure.userDepth),
      ]}
      rotation={[
        Helper.convertAngleToRadiant(0),
        Helper.convertAngleToRadiant(90),
        Helper.convertAngleToRadiant(0),
      ]}
    >
      <extrudeGeometry
        attach="geometry"
        args={[windowShape, { ...extrudeSettings }]}
      />
      <meshPhysicalMaterial
        color={color.white}
        transparent
        envMapIntensity={ego?.ego || night?.night ? 0.03 : 1}
        opacity={ego?.ego || night?.night? 0.4 : 0.5}
        metalness={ego?.ego || night?.night? 1 : 0.5}
        roughness={0}
      />
    </mesh>
  )
}
